import { SafeDepositBoxServiceAgreementProperties, SafeLocation } from 'pco-product-service-internal-consumer';
import i18n from '../../../i18n';
import { isSafeDepositBoxServiceAgreementProperties } from '../productSpecificProperties';

/** Branch codes CRMCH prints on the safe, keyed by the safe location the product carries. */
const SAFE_LOCATION_CODES: Record<SafeLocation, string> = {
  [SafeLocation.Basel]: 'BAS',
  [SafeLocation.Bern]: 'BER',
  [SafeLocation.CransMontana]: 'CRM',
  [SafeLocation.GenfRueFatio]: 'GVA-FAT',
  [SafeLocation.GenfRueDeLaFleche]: 'GVA-FLE',
  [SafeLocation.Lausanne]: 'LAU',
  [SafeLocation.Lugano]: 'LUG',
  [SafeLocation.Luzern]: 'LUC',
  [SafeLocation.Sion]: 'SIO',
  [SafeLocation.StMoritz]: 'STM',
  [SafeLocation.StGallen]: 'STG',
  [SafeLocation.Verbier]: 'VER',
  [SafeLocation.ZuerichBahnhofstrasse]: 'ZRH-BH',
  [SafeLocation.ZuerichMorgartenstrasse]: 'ZRH-MG',
};

export const getSafeLocationCode = (safeLocation: SafeLocation | undefined): string | undefined =>
  safeLocation === undefined ? undefined : SAFE_LOCATION_CODES[safeLocation];

export const getSafeDepositBoxProductDisplayName = (
  properties: SafeDepositBoxServiceAgreementProperties | undefined,
  fallbackName: string | undefined,
): string | undefined => {
  if (!isSafeDepositBoxServiceAgreementProperties(properties)) return fallbackName;

  const locationCode = getSafeLocationCode(properties.safeLocation);
  if (!locationCode || !properties.safeNr) return fallbackName;

  return i18n.t('pb.safedepositbox.productname', { locationCode, safeNumber: properties.safeNr });
};
